/**
 * @file reportWebVitals.js
 * @location src/utils/reportWebVitals.js
 * @role Core Web Vitals 측정 + 전송 transport
 *
 * 측정 항목 (Google 권장):
 *   CLS   Cumulative Layout Shift   — 예기치 못한 레이아웃 시프트
 *   LCP   Largest Contentful Paint  — 최대 콘텐츠 표시 시간
 *   INP   Interaction to Next Paint — 입력 응답성 (FID 후속)
 *   TTFB  Time to First Byte        — 초기 응답 시간
 *   FCP   First Contentful Paint    — 첫 콘텐츠 표시 시간
 *
 * transport injectable — 기본은 console. 추후 백엔드 (Sentry/Vercel Analytics 등) 도입 시 교체.
 *
 *   reportWebVitals();                                // 기본 console
 *   reportWebVitals((metric) => sendToBackend(metric)); // 커스텀
 */

import { debug, warn } from './debug.js';

const consoleReport = (metric) => {
  // dev 환경에선 친절한 라벨로 (prod 에선 무음 — transport 교체로 백엔드 전송)
  const { name, value, rating, id } = metric;
  debug(`[web-vitals] ${name} = ${value.toFixed(2)} (${rating}) [${id}]`);
};

/** @param {(metric: import('web-vitals').Metric) => void} [transport] */
export function reportWebVitals(transport = consoleReport) {
  if (typeof window === 'undefined') return; // SSR
  // web-vitals 는 lazy import — 측정 자체가 초기 번들에 영향 X
  import('web-vitals').then(({ onCLS, onLCP, onINP, onTTFB, onFCP }) => {
    try {
      onCLS(transport);
      onLCP(transport);
      onINP(transport);
      onTTFB(transport);
      onFCP(transport);
    } catch (err) {
      warn('[web-vitals] 측정 등록 실패:', err);
    }
  }).catch(err => {
    warn('[web-vitals] lazy import 실패:', err);
  });
}
